export { default } from './ModalTabs'
